// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1SywJ","clinicsSelect":"styles_clinicsSelect__1Y11e"};